module.exports = require("npm:process@0.11.9/browser.js");